import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import Button from "./Button";

class AddTemplateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      loading: false,
      error: ""
    };
  }
  handleSave = async () => {
    // redirect if no user is logged in
    /*  if (!this.props.loggedInUserQuery.loggedInUser) {
        console.warn("only logged in users can create new posts");
        return;
      }*/

    const { name } = this.state;
    const doctorId = this.props.doctorId;
    //    const authorId = this.props.loggedInUserQuery.loggedInUser.id;
    this.setState({
      loading: true
    });
    if (name.length > 0) {
      //check if name exists
      let found = false;
      for (let i = 0; i < this.props.allDayTemplates.length; i++) {
        let templateName = this.props.allDayTemplates[i].name;
        if (templateName === name) {
          found = true;
          break;
        }
      }
      if (found) {
        this.setState({
          error: "Ce template existe déjà!",
          name: "",
          loading: false
        });
      } else {
        await this.props
          .createDayTemplateMutation({
            variables: { name, doctorId }
          })
          .then(res => {
            let t = res.data.createDayTemplate;
            this.setState(
              {
                loading: false,
                name: "",
                error: ""
              },
              () => {
                this.props.toggleModal();
                this.props.setSelectedOption(t);
              }
            );
          })
          .catch(e => {
            e.graphQLErrors.forEach(error => {
              if (error.code === 3010) {
                this.setState({ error: "Ce template existe déjà!", name: "" });
              }
            });
            this.setState({
              loading: false
            });
          });
      }
    } else {
      this.setState({
        error: "Entrez au moins un caractère",
        name: "",
        loading: false
      });
    }
  };
  handleName = event => {
    this.setState(
      {
        name: event.target.value
      },
      this.handleChange
    );
  };

  handleChange = () => {
    if (this.state.name.length < 1) {
      this.setState({
        valid: false
      });
    } else {
      this.setState({
        valid: true
      });
    }
  };

  render() {
    return (
      <div className={"modal " + (this.props.isModalOpen ? "is-active" : "")}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Ajouter un template</p>
          </header>
          <section className="modal-card-body">
            <div className="field">
              <label className="label">Entrez le nom du nouveau template</label>
              <div className="control">
                <input
                  onChange={this.handleName}
                  className="input"
                  value={this.state.name}
                  type="text"
                  placeholder="Mon Template"
                />
              </div>
            </div>
          </section>
          <footer className="modal-card-foot">
            <p className="has-text-danger">{this.state.error}</p>
            <Button text="Retour" onClick={this.props.toggleModal} />
            <Button
              color="#00893D"
              text="Sauvegarder"
              onClick={this.handleSave}
            />
          </footer>
        </div>
      </div>
    );
  }
}

const CREATE_DAYTEMPLATE_MUTATION = gql`
  mutation CreateSlotTypeMutation($name: String!, $doctorId: ID!) {
    createDayTemplate(name: $name, doctorId: $doctorId) {
      id
      name
    }
  }
`;

export default graphql(CREATE_DAYTEMPLATE_MUTATION, {
  name: "createDayTemplateMutation"
})(AddTemplateModal);



// WEBPACK FOOTER //
// ./src/components/utilities/AddTemplateModal.js